import {
  Box,
  Button,
  Checkbox,
  Chip,
  Collapse,
  Grid,
  Typography,
} from "@mui/material";
import React, { useEffect, useState } from "react";
import MainCard from "../../../../components/Maincard";
import CustomSmallChip from "../../../newComponent/CustomChip/CustomSmallChip";
import CustomTextFieldComp from "../../../newComponent/customTextFieldComp";
import CustomAutocompleteComp from "../../../newComponent/AutocompleteComp";
import SearchButton from "../../../newComponent/NewButtonComp/SearchButton";
import ClearButtonComp from "../../../newComponent/NewButtonComp/ResetButtonComp";
import { DataGrid } from "@mui/x-data-grid";
import CustomNoRowsOverlay from "../../../newComponent/TableCustomeComp/CustomNoRowsOverlay";
import { useGetTokenOrLogout } from "../../../../utils/token";
import { useNavigate } from "react-router-dom";
import DetailedReportFilter from "./DetailedReportFilter";
import SearchTextFieldComp from "../../../newComponent/newtextfieldComp/SearchTextFieldComp";
import LoaderComp from "../../../newComponent/LoaderComp/Loader";
import CustomSnackbar from "../../../components/ui-component/snackbar/CustomSnackbar";
import SelectedItemButton from "../../../newComponent/NewButtonComp/SelectedItemButton";
import { fDate } from "../../../../utils/formatTime";
import { CSVExport } from "../../../components/ui-component/table/CSVExport";

const API_ENDPOINT = process.env.REACT_APP_API_ENDPOINT;
export default function RecycleDetailedReport({ open, isDownloadAccess }) {
  const getTokenOrLogout = useGetTokenOrLogout();
  const navigate = useNavigate();
  const userRole = localStorage.getItem("userRole");
  const userId = localStorage.getItem("userId");

  const [recycledData, setRecycleData] = useState([]);
  const [originalData, setOriginalData] = useState([]);
  const [SearchData, setSearchData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [pagination, setPagination] = useState({
    page: 0,
    pageSize: 100,
  });
  const [selectedIds, setSelectedIds] = useState([]);
  const [isSelectAllChecked, setIsSelectAllChecked] = useState(false);
  const [visibleRowIds, setVisibleRowIds] = useState([]); // Store current page's row IDs
  const [isIndeterminate, setIsIndeterminate] = useState(false);
  const [prevPageSize, setPrevPageSize] = useState(pagination.pageSize);
  const [gridKey, setGridKey] = useState(0);
  const [exportData, setExportData] = useState([]);
  const [snackbarOpen, setSnackbarOpen] = React.useState(false);
  const [snackbarMessage, setSnackbarMessage] = React.useState("");
  const [snackbarSeverity, setSnackbarSeverity] = React.useState("success");

  const showSnackbar = (message, severity) => {
    setSnackbarMessage(message);
    setSnackbarSeverity(severity);
    setSnackbarOpen(true);
  };

  useEffect(() => {
    setLoading(true);

    const token = getTokenOrLogout();
    if (!token) return;
    let headers = {
      Authorization: `Bearer ${token}`,
    };

    const fetchData = async () => {
      try {
        const response = await fetch(
          `${API_ENDPOINT}route2.0/recycle-report/${userId}`,
          { headers }
        );

        const data = await response.json();
        if (response.ok) {
          const sortedData = data.sort(
            (a, b) => new Date(b.createdAt) - new Date(a.createdAt)
          );
          setRecycleData(sortedData);
          setOriginalData(sortedData);
          setSearchData(sortedData);
          setLoading(false);
        } else if (response.status === 404) {
          navigate("/page404");
        } else if (response.status === 401) {
          navigate("/page401");
        } else if (response.status === 403) {
          navigate("/page403");
        } else if (response.status === 400) {
          showSnackbar(data.message, "error");
          setLoading(false);
        } else {
          navigate("/page500");
        }
      } catch {
        navigate("/page500");
      }
    };

    fetchData();
  }, [userId]);

  // select code

  // Upadate current page ids when pagination is chnages
  useEffect(() => {
    setPrevPageSize(pagination.pageSize);

    // new pagesize is less than prev page size then deselct all selected ids first
    if (pagination.pageSize !== prevPageSize) {
      setSelectedIds([]);
      return;
    }

    // Update visible row IDs when pagination changes
    const currentPageRows = recycledData.slice(
      pagination.page * pagination.pageSize,
      (pagination.page + 1) * pagination.pageSize
    );
    const visibleIds = currentPageRows.map((row) => row.id);
    setVisibleRowIds(visibleIds);

    // If there are no visible rows, set SelectAllChecked to false
    if (visibleIds.length === 0) {
      setIsSelectAllChecked(false);
      setIsIndeterminate(false);
      return;
    }

    // Check if all visible rows are selected
    const allVisibleSelected = visibleIds.every((id) =>
      selectedIds.includes(id)
    );
    const someVisibleSelected = visibleIds.some((id) =>
      selectedIds.includes(id)
    );

    setIsSelectAllChecked(allVisibleSelected);
    setIsIndeterminate(someVisibleSelected && !allVisibleSelected);
  }, [pagination, recycledData, selectedIds]);

  // HandleSelectAllCheckBox
  const handleSelectAllChange = (event) => {
    const checked = event.target.checked;
    setIsSelectAllChecked(checked);

    if (checked) {
      // Select all visible row IDs
      setSelectedIds((prevSelectedIds) => [
        ...new Set([...prevSelectedIds, ...visibleRowIds]),
      ]);
    } else {
      // Deselect all visible row IDs
      setSelectedIds((prevSelectedIds) =>
        prevSelectedIds.filter((id) => !visibleRowIds.includes(id))
      );
    }
  };

  // Individual CheckBox
  const handleCheckboxChange = (event, id) => {
    const checked = event.target.checked;

    setSelectedIds((prevSelectedIds) => {
      if (checked) {
        const newSelected = [...prevSelectedIds, id];
        // Check if all visible rows are selected after this checkbox is checked
        const allVisibleSelected = visibleRowIds.every((rowId) =>
          newSelected.includes(rowId)
        );
        setIsSelectAllChecked(allVisibleSelected);
        setIsIndeterminate(!allVisibleSelected);

        return newSelected;
      } else {
        // Deselect the row ID
        const newSelected = prevSelectedIds.filter((rowId) => rowId !== id);
        setIsSelectAllChecked(false);
        setIsIndeterminate(
          visibleRowIds.some((rowId) => newSelected.includes(rowId))
        );

        return newSelected;
      }
    });
  };

  // Select All Row
  const handleSelectAllData = () => {
    if (recycledData.length === selectedIds.length) {
      setSelectedIds([]);
    } else {
      const allRowIds = recycledData.map((row) => row.id);
      setSelectedIds(allRowIds);
    }
  };

  const columns = [
    {
      field: "selection",
      sortable: false,
      disableColumnMenu: true,
      renderHeader: (params) => (
        <Checkbox
          size="small"
          checked={isSelectAllChecked}
          indeterminate={isIndeterminate}
          onChange={handleSelectAllChange}
        />
      ),
      headerClassName: "header-cell",
      width: 70,
      renderCell: (params) => {
        const isChecked = selectedIds.includes(params.row?.id);
        return (
          <Checkbox
            size="small"
            checked={isChecked}
            onChange={(event) => handleCheckboxChange(event, params.row?.id)}
          />
        );
      },
    },

    {
      field: "name",
      headerName: "Name",

      width: 150,
      headerClassName: "header-cell",
      valueGetter: (params) => `${params.row?.enquiry_id?.first_name || ""}{" "}
${params.row?.enquiry_id?.last_name}`,
      renderCell: (params) => (
        <div>
          {" "}
          <div>
            <Button
              size="small"
              onClick={() =>
                window.open(`/enquirydetails/${params?.row?.enquiry_id?.id}`, "_blank")
              }
            >
              {params.row?.enquiry_id?.first_name}{" "}
              {params.row?.enquiry_id?.last_name ? params.row?.enquiry_id?.last_name : ""}
            </Button>
          </div>
        </div>
      ),
      headerAlign: "center",
      align: "center",
    },
    {
      field: "phone",
      headerName: "Mobile",
      width: 150,
      headerClassName: "header-cell",
      headerAlign: "center",
      align: "center",
      valueGetter: (params) => `${params.row?.enquiry_id?.mobile || ""}`,
      renderCell: (params) => (
        <div>
          {" "}
          {params.row?.enquiry_id?.mobile_country_code}
          {userRole === "advisor" || userRole === "trainer"
            ? params.row?.enquiry_id?.mobile?.replace(/.(?=.{4,}$)/g, "*")
            : params.row?.enquiry_id?.mobile}
        </div>
      ),
    },
    {
      field: "enquiry_date",
      headerName: "Enquiry Date",
      width: 150,
      headerClassName: "header-cell",
      valueGetter: (params) => params.row?.enquiry_id?.enquiry_date,
      renderCell: (params) => (
        <div>{params.row?.enquiry_id?.enquiry_date}</div>
      ),
      headerAlign: "center",
      align: "center",
    },

    {
      field: "nearest_branch",
      headerName: "Nearest  Branch",
      width: 150,
      headerClassName: "header-cell",
      valueGetter: (params) => params.row?.enquiry_id?.nearest_branch_id?.branch_name || "",
      renderCell: (params) => (
        <div>{params.row?.enquiry_id?.nearest_branch_id?.branch_name}</div>
      ),
      headerAlign: "center",
      align: "center",
    },

    {
      field: "service",
      headerName: "Service",
      width: 200,
      headerClassName: "header-cell",
      valueGetter: (params) => params.row?.enquiry_id?.service_id?.service_name || "",
      renderCell: (params) => <div>{params.row?.enquiry_id?.service_id?.service_name}</div>,
      headerAlign: "center",
      align: "center",
    },
    {
      field: "subService",
      headerName: "Sub Service",
      width: 250,
      headerClassName: "header-cell",
      valueGetter: (params) => params.row?.enquiry_id?.sub_service_id?.name || "",
      renderCell: (params) => <div>{params.row?.enquiry_id?.sub_service_id?.name}</div>,
      headerAlign: "center",
      align: "center",
    },
    {
      field: "leadSource",
      headerName: "Lead Source",
      width: 100,
      headerClassName: "header-cell",
      valueGetter: (params) => params.row?.enquiry_id?.lead_source_type_id?.name || "",
      renderCell: (params) => (
        <div>{params.row?.enquiry_id?.lead_source_type_id?.name}</div>
      ),
      headerAlign: "center",
      align: "center",
    },
    {
      field: "sublead",
      headerName: "Sub Lead Source",
      width: 150,
      headerClassName: "header-cell",
      valueGetter: (params) =>
        params.row?.enquiry_id?.sub_lead_source_type_id?.source_type || "",
      renderCell: (params) => (
        <div>{params.row?.enquiry_id?.sub_lead_source_type_id?.source_type}</div>
      ),
      headerAlign: "center",
      align: "center",
    },

    {
      field: "prospective_level",
      headerName: "Prospective Level",
      width: 150,
      headerClassName: "header-cell",
      valueGetter: (params) =>
        params.row?.enquiry_id?.prospective_level_id?.prospective_level || "",
      renderCell: (params) => (
        <div>{params.row?.enquiry_id?.prospective_level_id?.prospective_level}</div>
      ),
      headerAlign: "center",
      align: "center",
    },
    // {
    //   field: "campaign",
    //   headerName: "Sub Lead Source",
    //   width: 150,
    //   headerClassName: "header-cell",
    //   valueGetter: (params) =>
    //     params.row?.enquiry_id?.sub_lead_source_type_id?.source_type || "",
    //   renderCell: (params) => (
    //     <div>
    //       {params.row?.enquiry_id?.sub_lead_source_type_id?.source_type}
    //     </div>
    //   ),
    //   headerAlign: "center",
    //   align: "center",
    // },

    {
      field: "stage",
      headerName: "Stages",
      width: 150,
      headerClassName: "header-cell",
      valueGetter: (params) => params.row?.enquiry_id?.stage_id?.stage_name || "",
      renderCell: (params) => <div>{params.row?.enquiry_id?.stage_id?.stage_name}</div>,
      headerAlign: "center",
      align: "center",
    },
    {
      field: "branchName",
      headerName: " Branch",

      width: 150,
      headerClassName: "header-cell",
      valueGetter: (params) => params.row?.enquiry_id?.branch_id?.branch_name || "",
      renderCell: (params) => <div>{params.row?.enquiry_id?.branch_id?.branch_name}</div>,
      headerAlign: "center",
      align: "center",
    },
    {
      field: "assign_to",
      headerName: "Assign To",
      width: 150,
      headerClassName: "header-cell",
      valueGetter: (params) => `${params.row?.enquiry_id?.assign_to?.first_name || ""}{" "}
${params.row?.enquiry_id?.assign_to?.last_name || ""}`,
      renderCell: (params) => (
        <div>
          {params.row?.enquiry_id?.assign_to?.first_name} {params.row?.enquiry_id?.assign_to?.last_name}
        </div>
      ),
      headerAlign: "center",
      align: "center",
    },

    {
      field: "recycleBy",
      headerName: "Recycled By",
      width: 150,
      headerClassName: "header-cell",
      valueGetter: (params) => `${params.row?.recycle_by?.first_name || ""}{" "}
${params.row?.recycle_by?.last_name}`,
      renderCell: (params) => (
        <div>
          {params.row?.recycle_by?.first_name}{" "}
          {params.row?.recycle_by?.last_name}
        </div>
      ),
      headerAlign: "center",
      align: "center",
    },

    {
      field: "recycleReson",
      headerName: "Recycle Reason",
      width: 200,
      headerClassName: "header-cell",
      valueGetter: (params) =>
        params.row?.request_reason_id?.recycle_reason || "",
      renderCell: (params) => (
        <div>{params.row?.request_reason_id?.recycle_reason}</div>
      ),
      headerAlign: "center",
      align: "center",
    },
    {
      field: "requested_date",
      headerName: "Requested Date",
      width: 100,
      headerClassName: "header-cell",

      headerAlign: "center",
      align: "center",
    },
     {
      field: "action_by",
      headerName: "Action By",
      width: 100,
      headerClassName: "header-cell",
      valueGetter: (params) =>
        params.row?.action_by?.first_name || "",
      renderCell: (params) => (
        <div>{params.row?.action_by?.first_name} </div>
      ),
      headerAlign: "center",
      align: "center",
    },
    {
      field: "status",
      headerName: "Status",
      width: 100,
      headerClassName: "header-cell",
      renderCell: (params) => (
        <div>
          {params.row?.status === "pending" ? (
            <Chip
              size="small"
              label="Pending"
              variant="contained"
              sx={{ background: "#CFA31C", color: "white" }}
            />
          ) : params.row?.status === "accepted" ? (
            <Chip
              variant="contained"
              size="small"
              label="Accepted"
              color="secondary"
            />
          ) : params.row?.status === "cancelled" ? (
            <Chip
              variant="contained"
              size="small"
              label="Cancelled"
              color="error"
            />
          ) : params.row?.status === "reopen" ? (
            <Chip
              variant="contained"
              size="small"
              label="Reopened"
              color="primary"
            />
          ) : (
            " "
          )}
        </div>
      ),
      headerAlign: "center",
      align: "center",
    },
  ];

  // search all column in datagrid
  const handleSearchByName = (e) => {
    const value = e.target.value.toLowerCase().replace(/\s+/g, ""); // Normalize search value (lowercase and remove spaces)

    let filteredData1 = SearchData.filter((data) => {
      // Check each field for a match with the search value
      const fieldsToSearch = [
        `${data?.enquiry_id?.first_name || ""}
        ${data?.enquiry_id?.last_name || ""}`,
        `${data?.enquiry_id?.mobile_country_code}${data?.enquiry_id?.mobile}`,

        `${data.enquiry_id?.enquiry_date || ""}`,
        `${data?.enquiry_id?.nearest_branch_id?.branch_name || ""}`,
        `${data?.enquiry_id?.service_id?.service_name}`,
        `${data?.enquiry_id?.sub_service_id?.name}`,

        `${data?.enquiry_id?.lead_source_type_id?.name}`,
        `${data?.enquiry_id?.sub_lead_source_type_id?.source_type}`,
        `${data?.enquiry_id?.prospective_level_id?.prospective_level}`,
        `${data?.enquiry_id?.stage_id?.stage_name}`,
        `${data?.enquiry_id?.branch_id?.branch_name || ""}`,

        `${data?.enquiry_id?.assign_to?.first_name}  ${data?.enquiry_id?.assign_to?.last_name}`,
        ` ${data?.request_reason_id?.recycle_reason}`,
        `${data?.requested_date}`,
      ];

      // Check if any of the fields contain the search value
      return fieldsToSearch.some((field) =>
        field.toLowerCase().replace(/\s+/g, "").includes(value)
      );
    });

    setRecycleData(filteredData1); // Update the filtered data
  };

  useEffect(() => {
    const exportData = recycledData.map((row) => ({
      name: row?.enquiry_id?.last_name
        ? `${row?.enquiry_id?.first_name} ${row?.enquiry_id?.last_name}`
        : row?.enquiry_id?.first_name,
      mobile_country_code: row?.enquiry_id?.mobile_country_code || "",
      mobile: row?.enquiry_id?.mobile || "",

      enquiry_date: fDate(row?.enquiry_id?.enquiry_date || ""),

      nearest_branch: row?.enquiry_id?.nearest_branch_id?.branch_name || "",
      service: row?.enquiry_id?.service_id?.service_name,
      sub_service: row?.enquiry_id?.sub_service_id?.name,
      lead_source: row?.enquiry_id?.lead_source_type_id?.name,
      sub_lead_source: row?.enquiry_id?.sub_lead_source_type_id?.source_type,
      prospective_level: row?.enquiry_id?.prospective_level_id?.prospective_level,
      stage: row?.enquiry_id?.stage_id?.stage_name,
      branch: row?.enquiry_id?.branch_id?.branch_name,
      assign_to: `${row?.enquiry_id?.assign_to?.first_name || ""} ${
        row?.enquiry_id?.assign_to?.last_name || ""
      }`,
      recycle_by: `${row?.recycle_by?.first_name || ""} ${
        row?.recycle_by?.last_name || ""
      }`,
      recycle_reason: row?.request_reason_id?.recycle_reason,
      recycle_date: fDate(row?.requested_date),
      status: row?.status,
    }));
    setExportData(exportData);
  }, [recycledData]);

  return (
    <>
      <LoaderComp isLoading={loading} />

      <Grid container spacing={2}>
        {/* Filter comp */}
        <Grid item xs={12}>
          <Collapse in={open}>
            <MainCard>
              {/*  
              <Grid item xs={12} lg={12} sm={12} md={12}>
                <Typography
                  variant="h4"
                  sx={{
                    color: "#2E4069",

                    marginTop: "20px",
                  }}
                >
                  Sub Service
                </Typography>

                {allSubservice.map((subservice) => (
                  <Chip
                    size="small"
                    key={subservice.id}
                    onClick={() => handleChangeSubservice(subservice.id)}
                    variant="outlined"
                    label={
                      subservice.id === 0
                        ? subServiceName.length === subServiceList.length
                          ? "Deselect All"
                          : "Select All"
                        : subservice.name
                    }
                    style={{
                      color: subServiceName.includes(subservice.id)
                        ? "green"
                        : "black",
                      fontWeight: 500,
                      fontSize: "0.7rem",
                      margin: "5px",
                      border: subServiceName.includes(subservice.id)
                        ? "2px solid green"
                        : "",
                    }}
                  />
                ))}
              </Grid> */}

              {/* <Grid item xs={12} lg={12} sm={12} md={12}>
                <Typography
                  variant="h4"
                  sx={{ color: "#2E4069", fontWeight: 600 }}
                >
                  Duration
                </Typography>

                <Chip
                  size="small"
                  variant="outlined"
                  onClick={() => handleEventData("all")}
                  label="All"
                  style={{
                    borderRadius: "25px",

                    margin: "5px",
                    border: eventType === "all" ? "2px solid green" : "",
                    fontWeight: 500,
                    fontSize: "0.7rem",
                    color: eventType === "all" ? "green" : "black",
                  }}
                />

                <Chip
                  size="small"
                  variant="outlined"
                  onClick={() => handleEventData("past")}
                  label="Past"
                  style={{
                    borderRadius: "25px",

                    margin: "5px",
                    border: eventType === "past" ? "2px solid green" : "",
                    fontWeight: 500,
                    fontSize: "0.7rem",
                    color: eventType === "past" ? "green" : "black",
                  }}
                />

                <Chip
                  size="small"
                  variant="outlined"
                  onClick={() => handleEventData("last_one_year")}
                  label="Last One Year"
                  style={{
                    borderRadius: "25px",

                    margin: "5px",
                    border:
                      eventType === "last_one_year" ? "2px solid green" : "",
                    fontWeight: 500,
                    fontSize: "0.7rem",
                    color: eventType === "last_one_year" ? "green" : "black",
                  }}
                />

                <Chip
                  size="small"
                  variant="outlined"
                  onClick={() => handleEventData("custom")}
                  label="Custom"
                  style={{
                    borderRadius: "25px",

                    margin: "5px",
                    border: eventType === "custom" ? "2px solid green" : "",
                    fontWeight: 500,
                    fontSize: "0.7rem",
                    color: eventType === "custom" ? "green" : "black",
                  }}
                />

                {eventType === "custom" && (
                  <>
                    <CustomTextFieldComp
                      size="small"
                      InputProps={{ style: { borderRadius: "14px" } }}
                      InputLabelProps={{ shrink: true }}
                      type="date"
                      label="From Date"
                      variant="outlined"
                      sx={{ margin: "5px" }}
                      value={fromDate}
                      onChange={(e) => setFromDate(e.target.value)}
                    />

                    <CustomTextFieldComp
                      size="small"
                      InputProps={{ style: { borderRadius: "14px" } }}
                      InputLabelProps={{ shrink: true }}
                      type="date"
                      label="To Date"
                      variant="outlined"
                      sx={{ margin: "5px" }}
                      value={toDate}
                      onChange={(e) => setTodate(e.target.value)}
                    />
                  </>
                )}
              </Grid> */}

              <DetailedReportFilter
                recycledData={recycledData}
                setRecycleData={setRecycleData}
                originalData={originalData}
                SearchButton={SearchData}
                setSearchData={setSearchData}
                setLoading={setLoading}
                //  setSelectedEnquiryids={setSelectedEnquiryids}
                setVisibleRowIds={setVisibleRowIds}
                // setSelectedFilters={setSelectedFilters}
                setIsIndeterminate={setIsIndeterminate}
                setIsSelectAllChecked={setIsSelectAllChecked}
                setSelectedid={setSelectedIds}
                setGridKey={setGridKey}
              />
            </MainCard>
          </Collapse>
        </Grid>

        <Grid item xs={12}>
          <MainCard>
            <Grid container spacing={2}>
              <Grid item xs={12} sm={12} md={6} container gap={1}>
                {" "}
                <Chip
                  label={
                    recycledData.length === selectedIds.length
                      ? "Deselect All"
                      : "Select All"
                  }
                  variant="outlined"
                  size="small"
                  onClick={() => handleSelectAllData()}
                />
                <SelectedItemButton value={selectedIds.length} />
              </Grid>

              <Grid
                item
                xs={12}
                md={6}
                container
                justifyContent="end"
                alignItems="center"
                gap={1}
              >
                <SearchTextFieldComp onChange={handleSearchByName} />
                {isDownloadAccess && (
                  <CSVExport
                    data={exportData}
                    filename="recycle-enquiry-report.csv"
                  />
                )}
              </Grid>
              <Grid item xs={12}>
                <DataGrid
                  key={gridKey}
                  rows={recycledData}
                  columns={columns}
                  autoHeight
                  slots={{
                    noRowsOverlay: CustomNoRowsOverlay,
                  }}
                  pageSize={pagination.pageSize}
                  onPaginationModelChange={(model) => setPagination(model)}
                  pageSizeOptions={[10, 25, 50, 100]}
                  disableRowSelectionOnClick
                />
              </Grid>
            </Grid>
          </MainCard>
        </Grid>
      </Grid>
      <CustomSnackbar
        open={snackbarOpen}
        onClose={() => setSnackbarOpen(false)}
        message={snackbarMessage}
        severity={snackbarSeverity}
      />
    </>
  );
}
